import { FC, memo } from "react";
import { SIDE } from "_constants";
import { StatusMessageBase } from "components/common/StatusMessageBase";
import { isThreePointCode, isTwoPointCode } from "../constants";

type Props = {
  className?: string;
  team?: string | null;
  side: SIDE;
  Icon?: React.ComponentType<any>;
  title?: string;
  description?: string;
  normalizedCode: string;
  status: any;
  width: number;
  height: number;
};

export const StatusMessage: FC<Props> = memo((props) => {
  const bottomCodes = ["1077", "1062"];

  const sideIconResolver = (normalizedCode: string, side: "home" | "away") => {
    const { Icon } = props;
    const rotateCodes =
      normalizedCode === "1062" ||
      isTwoPointCode(normalizedCode) ||
      isThreePointCode(normalizedCode) ||
      normalizedCode === "1078";
    const isHome = side === "home";

    if (Icon && isHome && rotateCodes) {
      const Flipped: React.FC = () => (
        <div style={{ transform: "scaleX(-1)", transformOrigin: "center" }}>
          <Icon />
        </div>
      );
      return Flipped;
    }
    return Icon ?? null;
  };

  return (
    <StatusMessageBase
      {...props}
      bottomCodes={bottomCodes}
      accentColor="#53250A"
      sideIconResolver={sideIconResolver}
    />
  );
});
